import { type ReactNode } from 'react';
import { ArrowLeftRight } from 'lucide-react';

type Props = {
  canSwap: boolean;
  pending: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const CANCEL =
  'rounded-md px-md py-sm text-sm text-text-secondary transition-colors hover:text-text-primary';
const CONFIRM =
  'flex items-center gap-xs rounded-md bg-brand-red px-md py-sm text-sm font-medium text-white transition-colors hover:bg-brand-coral disabled:cursor-not-allowed disabled:opacity-50';

export function SwapIgActions({
  canSwap,
  pending,
  onCancel,
  onConfirm,
}: Props): ReactNode {
  return (
    <div className="mt-lg flex justify-end gap-sm">
      <button onClick={onCancel} className={CANCEL}>
        Cancelar
      </button>
      <button
        onClick={onConfirm}
        disabled={!canSwap || pending}
        className={CONFIRM}
      >
        <ArrowLeftRight size={14} />
        {pending ? 'Intercambiando...' : 'Intercambiar'}
      </button>
    </div>
  );
}
